module.exports = __webpack_public_path__ + "static/media/201IT119.27fdae9c.jpeg";